export class SignUpAsClientForm {
  public constructor(
    public readonly username: string,
    public readonly email: string,
    public readonly password: string,
    public readonly firstName: string,
    public readonly lastName: string,
    public readonly regulations: boolean,
    public readonly newsletter: boolean,
  ) {}
}
